export const capitalize = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1);

export const addSpacesInBetweenWords = (phrase: string): string => phrase.replace(/([a-z])([A-Z])/, '$1 $2');

/**
 * A tiny utility function used to truncate strings and tack on ellipses (if we have room to do so).
 *
 */
export function truncateWithEllipses(input: string = '', length: number = 0): string {
  if (length <= 0) return '';
  if (length < 3) return input.substring(0, length);
  if (input.length <= length) return input;
  return `${input.substring(0, length - 3)}...`;
}

/**
 * This is an alternative to `lodash/escape`. It runs exactly the same logic as Lodash, just
 * without the need for a dependency.
 *
 * @see {@link https://github.com/lodash/lodash/blob/f299b52f39486275a9e6483b60a410e06520c538/lodash.js#L14319C5-L14324C6}
 */
export function escapeHTML(input: string): string {
  const htmlEntities = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };

  return input.replace(/[&<>"']/g, match => htmlEntities[match]);
}
